import React from "react";
import "./RightElements.css";

const MotivationalClasament = () => (
  <div className="rightmenu-card motivational-clasament-card">
    <div className="section">
      <span className="get-pro-title">invata - castiga XP - avanseaza</span>
      <div className="section-desc" style={{ marginTop: 12 }}>
        Castiga XP rezolvand lectii, aplicatii si quiz-uri, apoi urca in clasament si demonstreaza-ti progresul.
      </div>
    </div>
  </div>
);

export default MotivationalClasament;
